import { SuspensePage } from '@/shared/ui/layout/SuspensePage';
import { PagesSupportStaffEditMain } from './modules/ui/Main';

const SupportStaffEditPage = (
  <SuspensePage>
    <PagesSupportStaffEditMain />
  </SuspensePage>
);

export default SupportStaffEditPage;
